import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBaseComponent } from "../../core/component/form-base/form-base.component";
import { FormControl, Validators, FormArray } from "@angular/forms";
import { AppState } from "../../../store/app-state";
import { Store } from "@ngrx/store";
import { CommerceService } from "../../../core/service/app/commerce.service";
import { forEach } from '@angular/router/src/utils/collection';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { AccountService } from 'app/core/service/app/account.service';


@Component({
  selector: "app-commerce-finance-form",
  templateUrl: "./commerce-finance-form.component.html",
  styleUrls: ["./commerce-finance-form.component.scss"]
})
export class CommerceFinanceFormComponent extends FormBaseComponent<any>
  implements OnInit {
  bankList$;

  totalExpenses = 0;
  totalIncome = 0;
  totalTPV = 20;
  current = 1;
  listatpv = [];
  formTpv : any[] = [];
  loadData: boolean = false;
  wizardId = 0;

  isSiema = false; 

  @Output()
  esPaso2Valido= new EventEmitter<boolean>();
  valido: boolean = true;

  completados = [];
  
  constructor(
    private store: Store<AppState>,
    private commerceService: CommerceService,
    private dialogService: DialogService,
    private accountService: AccountService
  ) {
    super();
    this.bankList$ = this.store.select(state => state.list.bank);

    this.store.subscribe(state => {
      
      
      if (state.user.data && state.user.data.id) {
        this.wizardId = state.user.data.id;
      }
    });

    /*this.commerceService.dataSub.subscribe(x => {
      x.register = this.commerceService.info.register;
      this.formTpv = [];
      if (x.register) {
        this.totalTPV = parseInt(x.register.creditCard + "");
      }
    });*/
  }
   
  ngOnInit() {
    this.init();
    
    this.form.statusChanges.subscribe(status=>{
      if(this.commerceService.info.register != undefined)
      {
        this.calculateTotalIncome();
        this.totalTPV = this.commerceService.info.register.creditCard;
        //this.formTpv = this.commerceService.info.finance.tpvs;
        //this.form.patchValue({ tpvs : this.commerceService.info.finance.tpvs });
        
        if(this.totalTPV != 0)
        {
          this.completados = [];
          for(var i= 0; i < this.totalTPV; i++)
          {
            this.completados.push(false);
          }
        }
      }
    });


  }

  calculateTotalIncome() {
    const tpv1 = parseFloat(
      this.form.value.tpv1 ? this.form.value.tpv1.averageAmount || 0 : 0
    );
    const tpv2 = parseFloat(
      this.form.value.tpv2 ? this.form.value.tpv2.averageAmount || 0 : 0
    );
    const tpv3 = parseFloat(
      this.form.value.tpv3 ? this.form.value.tpv3.averageAmount || 0 : 0
    );
    const tpv4 = parseFloat(
      this.form.value.tpv4 ? this.form.value.tpv4.averageAmount || 0 : 0
    );
    const tpv5 = parseFloat(
      this.form.value.tpv5 ? this.form.value.tpv5.averageAmount || 0 : 0
    );

    this.totalIncome = tpv1 + tpv2 + tpv3 + tpv4 + tpv5;
  }

  calculateExpenses() {
    /*const rent = parseFloat(this.form.value.rent || 0);
    const roster = parseFloat(this.form.value.roster || 0);
    const others = parseFloat(this.form.value.others || 0);
    const provider = parseFloat(this.form.value.provider || 0);
    const loans = parseFloat(this.form.value.loans || 0);

    this.totalExpenses = rent + roster + others + provider + loans;*/
    const tpv1 = parseFloat(
      this.form.value.tpv1 ? this.form.value.tpv1.chargebackAmount || 0 : 0
    );
    const tpv2 = parseFloat(
      this.form.value.tpv2 ? this.form.value.tpv2.chargebackAmount || 0 : 0
    );
    const tpv3 = parseFloat(
      this.form.value.tpv3 ? this.form.value.tpv3.chargebackAmount || 0 : 0
    );
    const tpv4 = parseFloat(
      this.form.value.tpv4 ? this.form.value.tpv4.chargebackAmount || 0 : 0
    );
    const tpv5 = parseFloat(
      this.form.value.tpv5 ? this.form.value.tpv5.chargebackAmount || 0 : 0
    );

    this.totalExpenses = tpv1 + tpv2 + tpv3 + tpv4 + tpv5;
  }


  template() {
    //this.form.addControl("tpvs", new FormArray([]));

    /*this.form.addControl("mensualQuantity", new FormControl(0));
    this.form.addControl("bank", new FormControl());

    this.form.addControl("rent", new FormControl());
    this.form.addControl("count", new FormControl(null, []));
    this.form.addControl("provider", new FormControl());
    this.form.addControl("roster", new FormControl());
    this.form.addControl("loans", new FormControl());
    this.form.addControl("others", new FormControl());*/
  }

  computeTotal() {
    return (
      parseFloat(this.totalIncome + "") +
      parseFloat(this.form.value.mensualQuantity)
    );
  }

  completartpv(monto) {
    if (monto > 0) {
      this.form.patchValue({ mensualQuantity: monto });
    }
  }
  pCompleto(data, i)
  {
    //if(data == false){ this.valido = data;}
    this.valido = true;
    this.completados[i] = data;
    this.completados.forEach(item => {
      if(item == false){ this.valido = false; }
    });

    this.esPaso2Valido.emit(this.valido);
  }

  //openAddTpv()
  //{
    //this.dialogService.addDialog(addTpvModalComponent, null, {backdropColor: 'rgba(100, 100, 100, 0.5)'}).subscribe(x => {
      //console.log('cerrado');
    //});
  //}

  addTpv()
  {
    this.commerceService.addNewTpv({ Id : this.wizardId }).then(tpvs => {
      this.commerceService.getWizard(this.wizardId).then(result => {
        if (result != null) {

          if (result) {
            this.form.patchValue({ appointment : result.appointment });
            this.form.patchValue({ finance : result.finance });
            this.form.patchValue({ general : result.general });
            this.form.patchValue({ offer : result.offer });
            this.form.patchValue({ register : result.register });
            this.form.patchValue({ registerR : result.register });
            this.form.patchValue({ sat : result.sat });
          }
          //this.form.patchValue({ tpvs : tpvs });
          //this.ngOnInit();
        }
        
      });


    })
  }
}



// WEBPACK FOOTER //
// ./src/app/form/form/commerce-finance-form/commerce-finance-form.component.ts